define("shared/components/shared/profile-categorization/rewards-steps/report/go-to-partial", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--m__b__xs u--text--light u--text--center">
    {{@socialProfile.displayNickname}}
  </p>
  <Shared::ProfileCategorization::SelectedTypes
    @businessModel={{@socialProfile.businessModel}}
    @category={{@socialProfile.category}}
    @handleResetSelection={{fn @clearSelectedCategory "summary"}}
    @industry={{@socialProfile.industry}}
    @prefix={{@prefix}}
  />
  <div class="tSC--result u--p__0" {{on "click" @toggleShowReportsStep}}>
    <div class="tSC--result__header">
      <span>
        {{t "profile_categorization.reports.partial.graphic_text" displayNickname=@socialProfile.displayNickname}}
      </span>
      {{svg-jar "arrow-right" class="o--icon u--float--right"}}
    </div>
    <img class="o--media" src="/assets/images/img--selfCat--report.png" />
  </div>
  <Shared::Ui::Button
    @additional="block"
    @onClick={{@toggleShowReportsStep}}
    @size="regular"
    class="o--btn u--m__t qa--categorize_show_reports_button"
  >
    {{t "profile_categorization.reports.partial.view_industry_report"}}
  </Shared::Ui::Button>
  {{#unless @isAnalyticsFlow}}
    <Shared::Ui::Button
      @additional="block"
      @size="regular"
      @text={{t "profile_categorization.reports.partial.skip_industry_report"}}
      @variant="outline"
      class="qa--categorize_reports_exit"
      {{on "click" @trackSkipRewards}}
      {{on "click" (fn @exitCategorization true)}}
    />
  {{/unless}}
  */
  {
    "id": "GobQgNYY",
    "block": "[[[10,2],[14,0,\"u--m__b__xs u--text--light u--text--center\"],[12],[1,\"\\n  \"],[1,[30,1,[\"displayNickname\"]]],[1,\"\\n\"],[13],[1,\"\\n\"],[8,[39,0],null,[[\"@businessModel\",\"@category\",\"@handleResetSelection\",\"@industry\",\"@prefix\"],[[30,1,[\"businessModel\"]],[30,1,[\"category\"]],[28,[37,1],[[30,2],\"summary\"],null],[30,1,[\"industry\"]],[30,3]]],null],[1,\"\\n\"],[11,0],[24,0,\"tSC--result u--p__0\"],[4,[38,2],[\"click\",[30,4]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"tSC--result__header\"],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"profile_categorization.reports.partial.graphic_text\"],[[\"displayNickname\"],[[30,1,[\"displayNickname\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[1,[28,[35,4],[\"arrow-right\"],[[\"class\"],[\"o--icon u--float--right\"]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--selfCat--report.png\"],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[8,[39,5],[[24,0,\"o--btn u--m__t qa--categorize_show_reports_button\"]],[[\"@additional\",\"@onClick\",\"@size\"],[\"block\",[30,4],\"regular\"]],[[\"default\"],[[[[1,\"\\n  \"],[1,[28,[35,3],[\"profile_categorization.reports.partial.view_industry_report\"],null]],[1,\"\\n\"]],[]]]]],[1,\"\\n\"],[41,[51,[30,5]],[[[1,\"  \"],[8,[39,5],[[24,0,\"qa--categorize_reports_exit\"],[4,[38,2],[\"click\",[30,6]],null],[4,[38,2],[\"click\",[28,[37,1],[[30,7],true],null]],null]],[[\"@additional\",\"@size\",\"@text\",\"@variant\"],[\"block\",\"regular\",[28,[37,3],[\"profile_categorization.reports.partial.skip_industry_report\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],null]],[\"@socialProfile\",\"@clearSelectedCategory\",\"@prefix\",\"@toggleShowReportsStep\",\"@isAnalyticsFlow\",\"@trackSkipRewards\",\"@exitCategorization\"],false,[\"shared/profile-categorization/selected-types\",\"fn\",\"on\",\"t\",\"svg-jar\",\"shared/ui/button\",\"unless\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/report/go-to-partial.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});